"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.delete.confirm.title': '删除问题',
    'question.delete.confirm.message': '确定要删除此问题吗？',
};
